import React from 'react';
import { Button, MessageBar, MessageBarBody, Text } from '@fluentui/react-components';
import { ArrowClockwise24Regular } from '@fluentui/react-icons';
import { Box, useFluentTokens } from '../../../theme/fluent';

interface FeatureLoadErrorProps {
  error: string;
  onRetry: () => void;
}

export const FeatureLoadError: React.FC<FeatureLoadErrorProps> = ({ 
  error, 
  onRetry 
}) => {
  const { tokens, modeTokens } = useFluentTokens();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      style={{
        height: '100vh',
        padding: tokens.spacingHorizontalXXXL,
        backgroundColor: modeTokens.colorNeutralBackground1,
      }}
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        style={{
          maxWidth: '500px',
          textAlign: 'center',
          gap: tokens.spacingVerticalL,
        }}
      >
        <Text
          size={600}
          weight="semibold"
          style={{
            color: modeTokens.colorNeutralForeground1,
          }}
        >
          Unable to Load Application Features
        </Text>

        <MessageBar intent="error">
          <MessageBarBody>
            <Text size={300}>
              {error}
            </Text>
          </MessageBarBody>
        </MessageBar>

        <Text
          size={300}
          style={{
            color: modeTokens.colorNeutralForeground2,
          }}
        >
          Please check your network connection and try again. If the problem persists, contact support.
        </Text>

        <Button
          appearance="primary"
          size="large"
          icon={<ArrowClockwise24Regular />}
          onClick={onRetry}
          style={{
            borderRadius: tokens.borderRadiusXXXXLarge,
            fontWeight: tokens.fontWeightSemibold,
          }}
        >
          Retry
        </Button>

        <Text
          size={200}
          style={{
            color: modeTokens.colorNeutralForeground3,
          }}
        >
          You can also try refreshing the page.
        </Text>
      </Box>
    </Box>
  );
};
